import React from 'react';
import { evidenceMeta } from '../lib/evidence';

// Tiny, muted, small-caps evidence label with a subtle left-border tint.
// Quiet research metadata — readable but subordinate to record content.
export const EvidenceLabel = ({ evidenceClass, className = '', testid }) => {
  const m = evidenceMeta(evidenceClass);
  if (!m) return null;
  return (
    <span
      title={`Evidence: ${m.label} — ${m.note}`}
      data-testid={testid || `evidence-${(evidenceClass || '').toLowerCase()}`}
      className={`inline-flex items-center pl-2 border-l-2 font-mono-tech text-[0.6rem] uppercase tracking-[0.14em] text-[#8a93a3] leading-none ${className}`}
      style={{ borderLeftColor: m.tint }}
    >
      {m.label}
    </span>
  );
};

// The kind of work a record represents (Part 4) — distinct from evidence class.
export const ValueLabel = ({ label, className = '', testid }) => {
  if (!label) return null;
  return (
    <span
      data-testid={testid || 'value-label'}
      className={`font-mono-tech text-[0.6rem] uppercase tracking-[0.14em] text-[#5b626f] leading-none ${className}`}
    >
      {label}
    </span>
  );
};

export default EvidenceLabel;
